<!--尖峰平谷-->
<template>
	<div class="evergyBody">
		<!--日期弹窗-->
		<datePicker :endCanSelect="endCanSelect" ref="datepicker" :initDate='bgDate' @selectDate="bgDate = $event" type="day"></datePicker>
		<datePicker :endCanSelect="endCanSelect" ref="datepicker2" :initDate='endDate' @selectDate="endDate = $event" type="day"></datePicker>
		<!--左边-->
		<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowItem = $event"></elRadioTree>
		<!--右边-->
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<!--日期-->
				<span>日期:</span>
				<iconButton icoName="wedoButton/date.png" :buttonText="getDateText(bgDate)" @buttonClick="showpicker(1)"></iconButton>
				<span> - </span>
				<iconButton icoName="wedoButton/date.png" :buttonText="getDateText(endDate)" @buttonClick="showpicker(2)"></iconButton>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
				<iconButton @buttonClick='exportReport' buttonText='导出' icoName="wedoButton/download.png"></iconButton>
			</div>
			<!--表格显示数据-->
			<div class="echart">
				<div class="leftEchart">
					<p class="chartTitle">占比分析</p>
					<vchart ref='vchartPie'></vchart>
				</div>
				<div class="rightEchart">
					<p class="chartTitle">累计趋势&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{nowItem.name}}</span></p>
					<vchart ref='vchartBar'></vchart>
				</div>
			</div>
			<div class="infolist">
				<p class="chartTitle">汇总表</p>
				<infoList class="panel_body_long" :columns='columns' :dataList="getInfoList" :pageLen='nowData.length < 5?5:nowData.length' :totalSize="nowData.length" :showIndex="false" :fillAll="true"></infoList>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import dateButton from '@/components/module/universal/dateButton.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			treeBody,
			infoList,
			datePicker,
			iconButton,
			dateButton,
			vchart,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				nowData: [],
				nowInfoList: [],
				nowItem: {
					name: ''
				}, //当前选中设备列表
				historyData: {}, //查询出来的历史数据,页码对应内容
				bgDate: new Date(new Date().getTime() - 60 * 60 * 24 * 1000),
				endDate: new Date(new Date().getTime() - 60 * 60 * 24 * 1000),
				endCanSelect: new Date(new Date().getTime() - 60 * 60 * 24 * 1000),
				columns: [{
						name: "名称",
						key: "name"
					},
					{
						name: "用电量(kWh)",
						key: "power"
					}, {
						name: "电费(元)",
						key: "money"
					}
				],
				optionsPie: {
					color: ['#00BFEF', '#ff9a16', '#ff6c4e'],
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						left: 'left',
					},
					series: []
				},
				optionsBar: {
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: [],
						axisTick: {
							alignWithLabel: true
						}
					},
					yAxis: {
						type: 'value'
					},
					series: []
				}
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.$refs.vchartPie.setData(this.optionsPie, true)
			this.$refs.vchartBar.setData(this.optionsBar, true)
			this.search()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			variableTree() {
				return no => {
					return this.$store.variableStore.getters.getVariableTree(no)
				}
			},
			virtualDeviceList() {
				if(isempty(this.nowUnit)) {
					return []
				}
				let tree = this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos('36', this.nowUnit.id)
				let list = []
				if(!isempty(tree)) {
					list = [deviceList(tree)]
				}
				return list
			},
			getInfoList() {
				var infos = []
				var countAll = 0
				var maxP = 0
				var minP = 0
				for(var i = 0, len = this.nowData.length; i < len; i++) {
					var item = this.nowData[i]
					var power = item.value
					var money = cutDigital(item.value * item.price)
					if(item.price > maxP) {
						maxP = item.price
					}
					if(item.price < minP) {
						minP = item.price
					}
					if(isNaN(parseFloat((power))) || isnull(parseFloat((power)))) {
						power = undefined
						money = undefined
					} else {
						countAll += parseFloat(money)
					}
					if(item.type == 'all') {
						infos.push({
							name: item.name,
							power,
							money: cutDigital(countAll)
						})
					} else if(item.type == 'uncount') {
						infos.push({
							name: item.name,
							power,
							money: cutDigital(item.value * minP) + ' - ' + cutDigital(item.value * maxP)
						})
					} else {
						infos.push({
							name: item.name,
							power,
							money
						})
					}

				}
				//倒数两个
				return infos
			},
			getPie() {
				var nameList = []
				var powerList = []
				var moneyList = []
				for(var i = 0, len = this.nowData.length; i < len; i++) {
					var item = this.nowData[i]
					if(item.type == "all" || item.type == "uncount") {
						continue
					}
					nameList.push(item.name)
					var pwValue = item.value
					var moneyValue = cutDigital(0)
					if(isNaN(parseFloat((pwValue))) || isnull(parseFloat((pwValue)))) {
						pwValue = undefined
					}

					if(!isempty(pwValue)) {
						moneyValue = cutDigital(item.value * item.price)
					}
					powerList.push({
						name: item.name,
						value: pwValue,
						label: {
							show: false
						},
						labelLine: {
							show: false,
							length: 0,
							length2: 0
						}
					})
					moneyList.push({
						name: item.name,
						value: moneyValue,
						label: {
							show: false
						},
						labelLine: {
							show: false,
							length: 0,
							length2: 0
						}
					})
				}
				return {
					series: [{
							name: '用电量(kWh)',
							type: 'pie',
							radius: [0, '40%'],
							data: powerList,
						},
						{
							name: '电费(元)',
							type: 'pie',
							radius: ['50%', '75%'],
							data: moneyList,
						}

					]
				}
			},
			getBar() {
				var nameList = []
				var powerList = []
				var moneyList = []
				for(var i = 0, len = this.nowData.length; i < len; i++) {
					var item = this.nowData[i]
					if(item.type == "all" || item.type == "uncount") {
						continue
					}
					nameList.push(item.name)
					var pwValue = item.value
					var moneyValue = cutDigital(0)
					if(isNaN(parseFloat((pwValue))) || isnull(parseFloat((pwValue)))) {
						pwValue = undefined
					}

					if(!isempty(pwValue)) {
						moneyValue = cutDigital(item.value * item.price)
					}
					powerList.push({
						name: item.name,
						value: pwValue,
					})
					moneyList.push({
						name: item.name,
						value: moneyValue //cutDigital(item.value * item.price)
					})
				}
				return {
					xAxis: {
						data: nameList
					},
					series: [{
						name: '电费(元)',
						type: 'bar',
						barWidth: '20%',
						itemStyle: {
							normal: {
								//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组#00BFEF
								color: function(params) {
									var colorList = ['#00BFEF', '#FF9A16', '#FF6C4E'];
									return colorList[params.dataIndex];
								}
							},
						},
						data: moneyList //this.nowData.price * this.nowData.price 
					}, {
						name: '用电量(kWh)',
						type: 'bar',
						barWidth: '20%',
						itemStyle: {
							normal: {
								//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
								color: function(params) {
									var colorList = ['#0c43f7', '#E77420', '#E0402B'];
									return colorList[params.dataIndex];
								}
							},
						},
						data: powerList
					}]

				}

			},
			getDateText() {
				return dateBean => {
					return dateBean.formatByDate('-')
				}
			}
		},
		watch: {
			getBar(nv, ov) {
				this.$refs.vchartBar.setData(nv)
			},
			getPie(nv, ov) {
				this.$refs.vchartPie.setData(nv)
			},
			nowItem(nv, ov) {
				this.search()
			},
			bgDate(nv, ov) {
				this.$refs.datepicker.hide()
				this.search()
			},
			endDate(nv, ov) {
				this.$refs.datepicker2.hide()
				this.search()
			},
		},
		methods: {
			exportReport() {
				//导出数据
				let start = new Date(this.bgDate.formatByDate() + " 00:00:00").getTime()
				let end = new Date(new Date(this.endDate).format('yyyy-MM-dd') + ' 23:59:59').getTime()
				let device = {}
				device[this.nowItem.no] = this.nowItem.name
				this.$api.powerApi.exportDevicePG(start, end, JSON.stringify(device), respon => {
					saveAs(DWSystemSetting.downloadUrl + '/' + respon, new Date(start).format('yyyy-MM-dd') + '到' + new Date(end).format('yyyy-MM-dd') + '的尖峰平谷表' + ".xls")
				})
			},
			showpicker(no) {
				if(no == 1) {
					this.$refs.datepicker.show()
				} else {
					this.$refs.datepicker2.show()
				}
			},
			checkItem(item) {
				this.nowDevice = item
				this.search()
			},
			search() {
				if(this.nowItem == undefined) {
					this.$dialogMethod.showMessage('请先选中一个组或者设备！')
					return
				}
				this.$dialogMethod.showLoading('正在查询数据...')
				var start = new Date(this.bgDate.formatByDate() + " 00:00:00").getTime()
				/*var end = this.endDate.getTime() + 24 * 60 * 60 * 1000*/
				let end = new Date(new Date(this.endDate).format('yyyy-MM-dd') + ' 23:59:59').getTime()
				var ignordList = ['all', 'uncount']
				if(this.nowItem.type == 'group') {
					//是组的
					this.$api.powerApi.getClassPG(this.nowItem.no, start, end,
						respon => {
							//结果需要处理一下，是多个设备的，要总加
							var deviceList = Object.values(respon)
							var idToBean = {}
							for(var i = 0, len = deviceList.length; i < len; i++) {
								var valueList = deviceList[i]
								//每个设备单独计算
								for(var i2 = 0, len2 = valueList.length; i2 < len2; i2++) {
									var item = valueList[i2]
									var temp = idToBean[item.id]
									if(temp == undefined) {
										temp = item
										temp.money = ignordList.includes(item.type) ? '-' : cutDigital(item.price * item.value)
										idToBean[item.id] = temp
										continue
									}
									temp.money += ignordList.includes(item.type) ? '-' : cutDigital(item.price * item.value)
									temp.power += item.value
								}
							}
							this.nowData = Object.values(idToBean).sort((a, b) => {
								return a.sort - b.sort
							})
							this.$dialogMethod.closeLoading();
						}, respon => {
							this.$dialogMethod.closeLoading();
							this.$dialogMethod.showMessage(respon)
						})
				} else {
					//是设备的
					var deviceNo = this.nowItem.no
					this.$api.powerApi.getDevicePG(deviceNo, start, end,
						respon => {
							if(respon[deviceNo] == undefined) {
								this.$dialogMethod.showMessage("数据缺失!")
								this.$dialogMethod.closeLoading()
								return
							}
							respon[deviceNo].forEach(item => {
								item.money = ignordList.includes(item.type) ? '-' : cutDigital(item.price * item.value)
							})
							this.nowData = respon[deviceNo]
							this.$dialogMethod.closeLoading()
						}, respon => {
							this.$dialogMethod.closeLoading()
						})
				}

			},
		}
	}
</script>

<style scoped>
	.echart {
		width: 100%;
		height: calc(100% - 3.6rem);
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: .1rem;
		background: white;
		margin-top: 10px;
	}
	
	.echart>>>.default-chart {
		height: calc(100% - .5rem);
		background: none;
		width: 100%;
		background-size: 100% 100%;
	}
	
	.leftEchart {
		width: 33%;
		margin-left: .1rem;
		height: 100%;
		background-size: 100% 100%;
	}
	
	.chartTitle {
		background-size: 100% 100%;
		height: 37px;
		line-height: 37px;
		font-size: 16px;
		padding-left: .1rem;
	}
	
	.rightEchart {
		width: calc(67% - .3rem);
		margin-left: .1rem;
		margin-right: .1rem;
		height: 100%;
	}
	
	.infolist {
		width: 100%;
		height: 2.8rem;
		margin-top: .1rem;
		background: white;
	}
	
	.infolist>>>.infoListBody {
		width: auto;
		height: calc(100% - 37px);
		padding: .01rem;
	}
	
	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.evergyBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
	}
</style>